import React, {Component} from 'react';
import {observer} from 'mobx-react';
import {Button, ButtonGroup, Dropdown, SplitButton} from 'react-bootstrap';

import Sort from "../../store/Sort";
import {SORT_TITLE} from "../../const/AppConst";
import {FaSortDown, FaSortUp} from "react-icons/fa";
import Styles from './Sort.module.scss';


@observer
class SortDropDown extends Component {


    render() {
        let {store, option} = this.props;
        let currentId = store?.sort?.id
        return (
            <Dropdown as={ButtonGroup}>
                <Dropdown.Toggle split variant={'secondary'} id="dropdown-split-basic" className={Styles.ToggleButton}>
                    {option[currentId]}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    {
                        Object.keys(option).map(id=>
                            <Dropdown.Item color={'secondary'}
                                           onClick={() => {
                                               if (store.sort.id !== id) {
                                                   store.sort = new Sort(id, Sort.SORT_DIRECTION.DESC)
                                               } else {
                                                   if (store.sort.direction === Sort.SORT_DIRECTION.DESC) {
                                                       store.sort = new Sort(id, Sort.SORT_DIRECTION.ASC)
                                                   } else {
                                                       store.sort = new Sort(id, Sort.SORT_DIRECTION.DESC)
                                                   }
                                               }
                                               store.debounceFetch(true);
                                           }}
                            >
                                {option[id]}
                            </Dropdown.Item>
                        )
                    }
                </Dropdown.Menu>
                <Button variant={'secondary'}
                        onClick={() => {
                            if (store.sort.direction === Sort.SORT_DIRECTION.DESC) {
                                store.sort = new Sort(currentId, Sort.SORT_DIRECTION.ASC)
                            } else {
                                store.sort = new Sort(currentId, Sort.SORT_DIRECTION.DESC)
                            }
                            store.debounceFetch(true);
                        }}
                >
                    {store.sort.direction === Sort.SORT_DIRECTION.ASC ? <FaSortUp color={`#fff`}/> : <FaSortDown color={'#fff'}/>}
                </Button>

            </Dropdown>

        );
    }
}

SortDropDown.propTypes = {};

export default SortDropDown;